module.exports = __webpack_public_path__ + "img/icon-application-w.ed58bc8f.svg";